import { iconSize, IconSizeProps } from '@/types/icons';

export const IconContainer2 = ({ size }: IconSizeProps) => {
  return (
    <svg
      fill="currentColor"
      className={iconSize[size]}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="28"
      viewBox="0 0 24 28"
      xmlSpace="preserve"
    >
      <path
        d="M22.4746 9.904L19.6159 26.9707C19.5711 27.2155 19.4421 27.437 19.2512 27.5967C19.0603 27.7565 18.8195 27.8444 18.5706 27.8453H5.42927C5.18035 27.8444 4.93958 27.7565 4.74868 27.5967C4.55777 27.437 4.42874 27.2155 4.38394 26.9707L1.52527 9.904C1.50064 9.7521 1.50918 9.59668 1.55028 9.4484C1.59138 9.30011 1.66407 9.16247 1.76338 9.04493C1.86268 8.92739 1.98624 8.83272 2.12558 8.76743C2.26492 8.70213 2.41673 8.66776 2.5706 8.66667H21.4079C21.5636 8.66466 21.7178 8.69675 21.8598 8.76069C22.0017 8.82463 22.1279 8.91886 22.2296 9.03677C22.3312 9.15469 22.4059 9.29342 22.4482 9.44324C22.4905 9.59306 22.4995 9.75033 22.4746 9.904ZM23.7333 5.46666C23.7333 5.74956 23.6209 6.02087 23.4209 6.22091C23.2208 6.42095 22.9495 6.53333 22.6666 6.53333H1.33327C1.05037 6.53333 0.77906 6.42095 0.579021 6.22091C0.378982 6.02087 0.266602 5.74956 0.266602 5.46666C0.266602 5.18377 0.378982 4.91246 0.579021 4.71242C0.77906 4.51238 1.05037 4.4 1.33327 4.4H6.6666V1.2C6.6666 0.9171 6.77898 0.64579 6.97902 0.445751C7.17906 0.245712 7.45037 0.133331 7.73327 0.133331H16.2666C16.5495 0.133331 16.8208 0.245712 17.0209 0.445751C17.2209 0.64579 17.3333 0.9171 17.3333 1.2V4.4H22.6666C22.9495 4.4 23.2208 4.51238 23.4209 4.71242C23.6209 4.91246 23.7333 5.18377 23.7333 5.46666ZM15.1999 4.4V2.26666H8.79994V4.4H15.1999Z"
        fill="#505050"
      />
    </svg>
  );
};
